import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var EngineeringIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    d: "M14.5 8V5.5H32.5V8H14.5ZM12 9V12V17.9146V20C12 20.6904 12.5596 21.25 13.25 21.25C13.9404 21.25 14.5 20.6904 14.5 20V19.9107C16.4756 19.5118 19.3053 19.0102 21.7943 18.832L27.4587 34.156C25.968 35.2477 25 37.0108 25 39L25.0001 39.0352C24.6061 38.8878 24.1528 38.9061 23.7547 39.1236C23.0277 39.5208 22.7604 40.4321 23.1576 41.1591L24.6746 43.9357C25.0719 44.6627 25.9832 44.93 26.7102 44.5328C27.0248 44.3609 27.2534 44.0927 27.3792 43.7848C28.3855 44.5475 29.6399 45 31 45C34.0128 45 36.5069 42.7795 36.9351 39.8857C37.2765 40.007 37.6626 40.0057 38.0224 39.8531C38.7851 39.5296 39.1411 38.6491 38.8177 37.8864L37.4862 34.7471C37.1627 33.9844 36.2822 33.6284 35.5196 33.9518C35.2637 34.0603 35.0536 34.2315 34.8996 34.4399C33.8509 33.5422 32.4888 33 31 33C30.7449 33 30.4935 33.0159 30.2467 33.0468L24.9869 18.8171C27.5275 18.9806 30.4663 19.5 32.5 19.9107V20C32.5 20.6904 33.0596 21.25 33.75 21.25C34.4404 21.25 35 20.6904 35 20V17.9146V12V5C35 3.89543 34.1046 3 33 3H14C12.8954 3 12 3.89543 12 5V9ZM32.5 12V10H14.5V12V17.3616C16.9673 16.8775 20.6282 16.2653 23.5 16.2653C26.3718 16.2653 30.0327 16.8775 32.5 17.3616V12ZM34.5 39C34.5 40.933 32.933 42.5 31 42.5C29.067 42.5 27.5 40.933 27.5 39C27.5 37.067 29.067 35.5 31 35.5C32.933 35.5 34.5 37.067 34.5 39Z"
  }));
});
EngineeringIcon.displayName = 'EngineeringIcon';
EngineeringIcon.defaultProps = {
  'aria-label': 'Engineering'
};
export default EngineeringIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/EngineeringIcon/index.js
// module id = 1992
// module chunks = 12